import { MGPOptional, Utils } from '@everyboard/lib';
import { Orthogonal } from '../../jscaip/Orthogonal';
import { Player, PlayerOrNone } from '../../jscaip/Player';
export class SiamPiece {
    value;
    owner;
    direction;
    static EMPTY = new SiamPiece(0, PlayerOrNone.NONE, MGPOptional.empty());
    static LIGHT_UP = new SiamPiece(1, PlayerOrNone.ONE, MGPOptional.of(Orthogonal.UP));
    static LIGHT_RIGHT = new SiamPiece(2, PlayerOrNone.ONE, MGPOptional.of(Orthogonal.RIGHT));
    static LIGHT_DOWN = new SiamPiece(3, PlayerOrNone.ONE, MGPOptional.of(Orthogonal.DOWN));
    static LIGHT_LEFT = new SiamPiece(4, PlayerOrNone.ONE, MGPOptional.of(Orthogonal.LEFT));
    static DARK_UP = new SiamPiece(5, PlayerOrNone.ZERO, MGPOptional.of(Orthogonal.UP));
    static DARK_RIGHT = new SiamPiece(6, PlayerOrNone.ZERO, MGPOptional.of(Orthogonal.RIGHT));
    static DARK_DOWN = new SiamPiece(7, PlayerOrNone.ZERO, MGPOptional.of(Orthogonal.DOWN));
    static DARK_LEFT = new SiamPiece(8, PlayerOrNone.ZERO, MGPOptional.of(Orthogonal.LEFT));
    static MOUNTAIN = new SiamPiece(9, PlayerOrNone.NONE, MGPOptional.empty());
    static decode(value) {
        switch (value) {
            case 0: return SiamPiece.EMPTY;
            case 1: return SiamPiece.LIGHT_UP;
            case 2: return SiamPiece.LIGHT_RIGHT;
            case 3: return SiamPiece.LIGHT_DOWN;
            case 4: return SiamPiece.LIGHT_LEFT;
            case 5: return SiamPiece.DARK_UP;
            case 6: return SiamPiece.DARK_RIGHT;
            case 7: return SiamPiece.DARK_DOWN;
            case 8: return SiamPiece.DARK_LEFT;
            case 9: return SiamPiece.MOUNTAIN;
        }
    }
    static of(orientation, player) {
        if (player === Player.ZERO) {
            if (orientation === Orthogonal.UP)
                return SiamPiece.DARK_UP;
            if (orientation === Orthogonal.RIGHT)
                return SiamPiece.DARK_RIGHT;
            if (orientation === Orthogonal.DOWN)
                return SiamPiece.DARK_DOWN;
            return SiamPiece.DARK_LEFT;
        }
        else {
            if (orientation === Orthogonal.UP)
                return SiamPiece.LIGHT_UP;
            if (orientation === Orthogonal.RIGHT)
                return SiamPiece.LIGHT_RIGHT;
            if (orientation === Orthogonal.DOWN)
                return SiamPiece.LIGHT_DOWN;
            return SiamPiece.LIGHT_LEFT;
        }
    }
    constructor(value, owner, direction) {
        this.value = value;
        this.owner = owner;
        this.direction = direction;
    }
    belongsTo(player) {
        return this.owner.equals(player);
    }
    isEmptyOrMountain() {
        return this.owner.isNone();
    }
    isPlayer() {
        return this.isEmptyOrMountain() === false;
    }
    getOwner() {
        return this.owner;
    }
    getOptionalDirection() {
        return this.direction;
    }
    getDirection() {
        return this.getOptionalDirection().get();
    }
    equals(other) {
        return this === other;
    }
    toString() {
        switch (this) {
            case SiamPiece.EMPTY: return 'EMPTY';
            case SiamPiece.LIGHT_UP: return 'LIGHT_UP';
            case SiamPiece.LIGHT_RIGHT: return 'LIGHT_RIGHT';
            case SiamPiece.LIGHT_DOWN: return 'LIGHT_DOWN';
            case SiamPiece.LIGHT_LEFT: return 'LIGHT_LEFT';
            case SiamPiece.DARK_UP: return 'DARK_UP';
            case SiamPiece.DARK_RIGHT: return 'DARK_RIGHT';
            case SiamPiece.DARK_DOWN: return 'DARK_DOWN';
            case SiamPiece.DARK_LEFT: return 'DARK_LEFT';
            default:
                // must be 9, according to this.value's type
                Utils.expectToBe(this, SiamPiece.MOUNTAIN);
                return 'MOUNTAIN';
        }
    }
}
